import React from 'react';
import { onSetStudents } from '../../../data/student/student.service';
import { BalanceModel, StudentResponseModel } from 'data/student/student.model';
import { ParentResponseModel } from 'data/parent/parent.model';
import { onSetParents } from 'data/parent/parent.service';
import { IssueBookModel } from 'data/library/issueBook/issueBook.model';
import { onSetIssueBook } from 'data/library/issueBook/issueBook.service';
import { CardModel } from 'data/card/card.model';
import { onUpdateBalance } from 'data/balance/balance.service';
import { onSetCard } from 'data/card/card.service';
import { notifyError, notifySuccess } from 'common/helper/notifications';
import decodeApiMessage from 'common/helper/decodeApiMessage';
import {
  AssignParentToStudentModel,
  CreateStudentAndAssignNewParentModel,
  CreateStudentAndAssignParentModel,
  ManagerResponseModel,
} from 'data/manager/manager.model';
import {
  onAssignParentToStudent,
  onSetManagers,
  onSetStudentAndAssignNewParent,
  onSetStudentAndAssignParent,
} from 'data/manager/manager.service';
import { SupportPersonResponseModel } from 'data/supportPerson/supportPerson.model';
import { onSetSupportPerson } from 'data/supportPerson/supportPerson.service';
import { TeacherResponseModel } from 'data/teacher/teacher.model';
import { onSetTeachers } from 'data/teacher/teacher.service';
import { AlertNoticeModel } from 'data/alert/alert.model';
import { onSetAlertNotice } from 'data/alert/alert.service';
import { FormInstance } from 'antd/lib/form';
import { useUser } from './useUser';
import { FaDoorClosed } from 'react-icons/fa';

export const useSave = () => {
  const [error, seterror] = React.useState<string | null | boolean>(null);
  const { fetchBalance } = useUser();

  const onCreateStudentAndAssignParent = async (
    payload: CreateStudentAndAssignParentModel,
    form: FormInstance,
    onVisibleChange: any,
    setSearchClicked: any,
  ) => {
    try {
      await onSetStudentAndAssignParent(payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
        setSearchClicked(false);
      });
      notifySuccess('Success', 'Student Created and new parent assigned');
    } catch (error) {
      seterror(error);
      onVisibleChange(false);
      notifyError('Error', decodeApiMessage(error));
    }
  };
  const onCreateStudentAndAssignNewParent = async (
    payload: CreateStudentAndAssignNewParentModel,
    form: FormInstance,
    onVisibleChange: any,
    setReloadAfterDrawer: any,
  ) => {
    try {
      await onSetStudentAndAssignNewParent(payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
        setReloadAfterDrawer(true);
      });
      notifySuccess('Success', 'Student Created and new parent assigned');
    } catch (error) {
      seterror(error);
      onVisibleChange(true);
      setReloadAfterDrawer(false);
      notifyError('Error', decodeApiMessage(error));
    }
  };

  const onStudentSave = async (
    payload: StudentResponseModel,
    form: FormInstance,
    onVisibleChange: any,
    setReloadAfterDrawer: any,
  ) => {
    try {
      await onSetStudents(payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
        setReloadAfterDrawer(true);
      });
      notifySuccess('Success', 'Student successfully added.');
    } catch (err) {
      seterror(err);
      onVisibleChange(true);
      setReloadAfterDrawer(false);
      notifyError('Error', decodeApiMessage(err));
    }
  };
  const onParentSave = async (
    payload: ParentResponseModel,
    form: FormInstance,
    onVisibleChange: any,
    setReloadAfterDrawer: any,
  ) => {
    try {
      await onSetParents(payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
        setReloadAfterDrawer(true);
      });
      notifySuccess('Success', 'Parent successfully added.');
    } catch (err) {
      seterror(err);
      onVisibleChange(true);
      setReloadAfterDrawer(false);
      notifyError('Error', decodeApiMessage(err));
    }
  };
  const onManagerSave = async (
    payload: ManagerResponseModel,
    form: FormInstance,
    onVisibleChange: any,
    setReloadAfterDrawer: any,
  ) => {
    try {
      await onSetManagers(payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
        setReloadAfterDrawer(true);
      });
      notifySuccess('Success', 'Manager successfully added.');
    } catch (err) {
      seterror(err);
      onVisibleChange(true);
      setReloadAfterDrawer(false);
      notifyError('Error', decodeApiMessage(err));
    }
  };
  const onSupportPersonSave = async (
    payload: SupportPersonResponseModel,
    form: FormInstance,
    onVisibleChange: any,
    setReloadAfterDrawer: any,
  ) => {
    try {
      await onSetSupportPerson(payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
        setReloadAfterDrawer(true);
      });
      notifySuccess('Success', 'Support Person successfully added.');
    } catch (err) {
      seterror(err);
      onVisibleChange(true);
      setReloadAfterDrawer(false);
      notifyError('Error', decodeApiMessage(err));
    }
  };
  const onTeacherSave = async (
    payload: TeacherResponseModel,
    form: FormInstance,
    onVisibleChange: any,
    setReloadAfterDrawer: any,
  ) => {
    try {
      await onSetTeachers(payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
        setReloadAfterDrawer(true);
      });

      notifySuccess('Success', 'Teacher successfully added.');
    } catch (err) {
      seterror(err);
      onVisibleChange(true);
      setReloadAfterDrawer(false);
      notifyError('Error', decodeApiMessage(err));
    }
  };

  const onIssueBook = async (payload: IssueBookModel, form: FormInstance, onVisibleChange: any) => {
    try {
      await onSetIssueBook(payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
      });
      notifySuccess('Success', 'Successfully book issued.');
    } catch (err) {
      seterror(err);
      onVisibleChange(false);
      notifyError('Error', decodeApiMessage(err));
    }
  };

  const onLoadBalance = async (
    cardNumber: string,
    payload: BalanceModel,
    form: FormInstance,
    onVisibleChange: any,
    setReloadAfterDrawer: any,
  ) => {
    try {
      await onUpdateBalance(cardNumber, payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
        setReloadAfterDrawer(true);
      });
      notifySuccess('Success', 'Successfully balance added.');
    } catch (err) {
      seterror(err);
      onVisibleChange(false);
      setReloadAfterDrawer(false);

      notifyError('Error', decodeApiMessage(err));
    }
  };

  const onCardSave = async (
    userId: string,
    payload: CardModel,
    form: FormInstance,
    onVisibleChange: any,
    setReloadAfterDrawer: any,
  ) => {
    try {
      await onSetCard(userId, payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
        setReloadAfterDrawer(true);
      });
      notifySuccess('Success', 'Card successfully added.');
    } catch (err) {
      seterror(err);
      onVisibleChange(false);
      setReloadAfterDrawer(false);

      notifyError('Error', decodeApiMessage(err));
    }
  };
  const onAssignPToS = async (
    payload: AssignParentToStudentModel,
    form: FormInstance,
    onVisibleChange: any,
    setSearchClicked: any,
  ) => {
    try {
      await onAssignParentToStudent(payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
        setSearchClicked(false);
      });
      notifySuccess('Success', 'Parent successfully assigned to Student.');
    } catch (err) {
      seterror(err);
      onVisibleChange(false);
      notifyError('Error', decodeApiMessage(err));
    }
  };
  const onAlertNoticeSave = async (
    payload: AlertNoticeModel,
    form: FormInstance,
    onVisibleChange: any,
  ) => {
    try {
      await onSetAlertNotice(payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
      });
      notifySuccess('Success', 'Alert Notice successfully added.');
    } catch (err) {
      seterror(err);
      onVisibleChange(false);

      notifyError('Error', decodeApiMessage(err));
    }
  };
  return {
    onStudentSave,
    onParentSave,
    onManagerSave,
    onSupportPersonSave,
    onTeacherSave,
    onIssueBook,
    onLoadBalance,
    onCardSave,
    onAssignPToS,
    onAlertNoticeSave,
    onCreateStudentAndAssignParent,
    onCreateStudentAndAssignNewParent,
  };
};
